import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.prepareForPrint = this.prepareForPrint.bind(this);
    this.cleanupAfterPrint = this.cleanupAfterPrint.bind(this);

    window.addEventListener("beforeprint", this.prepareForPrint);
    window.addEventListener("afterprint", this.cleanupAfterPrint);
  }

  disconnect() {
    window.removeEventListener("beforeprint", this.prepareForPrint);
    window.removeEventListener("afterprint", this.cleanupAfterPrint);
  }

  print(event) {
    if (event) event.preventDefault();
    window.print();
  }

  prepareForPrint() {
    const details = this.element.querySelectorAll("details");

    details.forEach((el) => {
      el.dataset.wasOpen = el.hasAttribute("open");
      el.dataset.hadName = el.getAttribute("name") || "";
      el.removeAttribute("name");
      el.setAttribute("open", "");
    });

    // Eager load images
    const images = document.querySelectorAll("img[loading='lazy']");
    images.forEach((img) => {
      img.dataset.wasLazy = "true";
      img.setAttribute("loading", "eager");
    });
  }

  cleanupAfterPrint() {
    const details = this.element.querySelectorAll("details");

    details.forEach((el) => {
      if (el.dataset.hadName) {
        el.setAttribute("name", el.dataset.hadName);
      }
      if (el.dataset.wasOpen === "false") {
        el.removeAttribute("open");
      }
      delete el.dataset.wasOpen;
      delete el.dataset.hadName;
    });

    // Restore images
    const images = document.querySelectorAll("img[data-was-lazy='true']");
    images.forEach((img) => {
      img.setAttribute("loading", "lazy");
      delete img.dataset.wasLazy;
    });
  }
}
